<template>
  <div>
    <van-field
      v-model.number="verification"
      maxlength="6"
      center
      clearable
      placeholder="请输入验证码"
    >
      <i slot="left-icon">
        <img class="yanzhengma" src="../assets/yanzhengma.png" alt />
      </i>
      <template #button>
        <van-count-down
          v-if="timeDown"
          :time="60000"
          format="重新发送ss s"
          @change="countDown($event)"
        />
        <button v-else class="Btn" type="primary" @click="sendVcode()">
          发送验证码
        </button>
      </template>
    </van-field>
  </div>
</template>

<script>
import { getMsg } from "@/Api/login";
export default {
  props: {
    phone: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      timeDown: false,
      verification: "",
    };
  },
  methods: {
    countDown({ days, hours, minutes, seconds }) {
      if (!days && !hours && !minutes && !seconds) {
        this.timeDown = false;
      }
    },

    // 点击发送验证码
    async sendVcode() {
      try {
        const { data } = await getMsg({
          user_acc: this.phone,
        });
        if (data.code == 2033) {
          this.$message({
            showClose: true,
            message: data.message,
            type: "warning",
          });
        }
      this.$emit("child-event", this.verification);
      } catch (err) {
        console.log(err);
      }
      //   if (this.phone) {
      this.timeDown = true;
      //   } else {
      //     console.log("请输入手机号");
      //   }
    },
  },
};
</script>

<style lang="less" scoped>
.yanzhengma {
  width: 26px;
  height: 30px;
  margin-right: 17px;
}
.Btn {
  width: 100px;
  height: 30px;
  border: 0;
  border-radius: 10px;
}
</style>
